// UpcomingClassesSidebar.jsx
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from './Constants';
const UpcomingClassesSidebar = ({ studentId }) => {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
   const [flagged, setFlagged] = useState(false);
  
  // Replace with your actual API base URL

  useEffect(() => {
    const fetchSessions = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/sessions`);
        // Filter sessions by student ID from enrollment
        const filteredData = res.data.filter(session => 
          session.enrollment?.student_id === studentId
        );
        setSessions(filteredData);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching sessions', err);
        setError('Failed to load sessions');
        setLoading(false);
      }
    };

    fetchSessions();
  }, [studentId]);

  // Format date and time for display
  const formatDateTime = (scheduled_time) => {
    const date = new Date(scheduled_time);
    return {
      date: date.toLocaleDateString({ weekday: 'short', month: 'short', day: 'numeric' }),
      time: date.toLocaleTimeString({ hour: '2-digit', minute: '2-digit' })
    };
  };

  if (loading) {
    return (
      <div className="w-80 bg-base-200 h-screen overflow-y-auto p-4 shadow-xl">
        <h2 className="text-2xl font-bold mb-6 text-primary">Upcoming Classes</h2>
        <div className="flex justify-center items-center h-40">
          <span className="loading loading-spinner loading-lg text-primary"></span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="w-80 bg-base-200 h-screen overflow-y-auto p-4 shadow-xl">
        <h2 className="text-2xl font-bold mb-6 text-primary">Upcoming Classes</h2>
        <div className="alert alert-error">
          <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span>{error}</span>
        </div>
      </div>
    );
  }

  // Filter to only show scheduled sessions
  const upcomingClasses = sessions.filter(session => session.status === 'scheduled');

  return (
    <div className="w-80 bg-base-200 h-screen overflow-y-auto p-4 shadow-xl">
      <h2 className="text-2xl font-bold mb-6 text-primary">Upcoming Classes</h2>
      
      {upcomingClasses.length === 0 ? (
        <div className="alert alert-info">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="stroke-current shrink-0 w-6 h-6">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          <span>No upcoming classes</span>
        </div>
      ) : (
        <div className="space-y-4">
{upcomingClasses.map((classItem) => {
  const { date } = formatDateTime(classItem.scheduled_time);
  const time = new Date(classItem.scheduled_time).toLocaleTimeString('en-IN', { 
    hour: '2-digit', 
    minute: '2-digit',
     });
  
  return (
    <div key={classItem.id} className="card bg-base-100 shadow-md">
      <div className="card-body p-4">
        <h3 className="card-title text-lg">
          {classItem.enrollment ? classItem.enrollment.course_name: "Untitled Course"}
        </h3>
        <div className="flex items-center text-sm text-gray-500 mb-2">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          <span>{date}</span>
        </div>
        <div className="flex items-center text-sm text-gray-500 mb-3">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span>{time} • {classItem.duration_minutes} mins</span>
        </div>
                  
                  <div className="card-actions justify-start mt-2">
                    {classItem.meeting_link ? (
                      <a 
                        href={classItem.meeting_link} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="btn btn-primary btn-sm"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                        </svg>
                        Join Google Meet
                      </a>
                    ) : (
                      <button className="btn btn-disabled btn-sm">
                        No meeting link
                      </button>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default UpcomingClassesSidebar;